import { render, staticRenderFns } from "./ProductLabelSkuList.vue?vue&type=template&id=6e16b4e1&scoped=true&"
import script from "./ProductLabelSkuList.vue?vue&type=script&lang=js&"
export * from "./ProductLabelSkuList.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelSkuList.vue?vue&type=style&index=0&id=6e16b4e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e16b4e1",
  null
  
)

export default component.exports